import Axios from 'axios';
import * as channelActions from './channelReducer';
import queryString from '../../../helpers/queryString';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import { push } from 'react-router-redux';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';
import { toastr } from 'react-redux-toastr';

export const defaultIncludes = [];

const getChannel = (id, includes = defaultIncludes) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    let endpoint = 'channels/' + id;
    endpoint += queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: channelActions.SET_CHANNEL,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.name,
        });
        dispatch(isLoading(false));
        return response.data;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getChannelByKey = (key, includes = defaultIncludes) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    let endpoint = 'public/channels/' + key;
    endpoint += queryString(includes);

    return Axios.post(endpoint)
      .then((response) => {
        dispatch({
          type: channelActions.SET_CHANNEL,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.name,
        });
        dispatch(isLoading(false));
        return response.data;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const setChannels = () => {
  let endpoint = 'channels';

  return (dispatch) => {
    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: channelActions.SET_CHANNELS,
          data: response.data.data,
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const resetSelectedChannel = () => ({ type: channelActions.RESET_CHANNEL });

const createChannel = (resource) => {
  return (dispatch) => {
    return Axios.post('channels', resource)
      .then((response) => {
        dispatch(push('/admin/channels/' + response.data.data.id));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating the channel');
      });
  };
};

const isLoading = (status) => {
  return {
    type: channelActions.IS_LOADING,
    status,
  };
};

const getAllInsurers = () => {
  const endpoint = 'organisations/insurers';
  const pagelimit = '?page[limit]=500';

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(endpoint + pagelimit)
      .then((response) => {
        dispatch({ type: channelActions.SET_CHANNEL_INSURERS, data: response.data.data });
        dispatch(isLoading(false));
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const getAllSchemes = () => {
  const endpoint = 'products/schemes';
  const filters = '?filter[status]=all&page[limit]=500&include=insurer';

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.get(endpoint + filters)
      .then((response) => {
        dispatch({ type: channelActions.SET_ALL_SCHEMES, data: response.data.data });
        dispatch(isLoading(false));
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const updateChannel = (channelId, data) => {
  const endpoint = `channels/${channelId}:update-schemes`;

  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.post(endpoint, data)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isLoading(false));
        dispatch(getChannel(channelId, ['schemes,schemes.insurer']));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to perform this action.');
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};
//
// const updateWhitelabel = (channelId, data) => {
//   const endpoint = `channels/${channelId}:update-default-whitelabel`;
//
//   return (dispatch) => {
//     dispatch(isLoading(true));
//     return Axios.post(endpoint, data)
//       .then(() => {
//         toastr.success('Success', ' Your changes has been saved.');
//         dispatch(isLoading(false));
//         dispatch(getChannel(channelId, ['schemes,schemes.insurer']));
//         return true;
//       })
//       .catch((error) => {
//         handleErrorResponse(error, 'Failed to perform this action.');
//         dispatch(isLoading(false));
//         console.error(error);
//       });
//   };
// };

const updateWhitelabel = (channelId, data) => {
  const endpoint = `whitelabel-management/channel/${channelId}/update-white-label`;
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.patch(endpoint, data)
      .then(() => {
        toastr.success('Success', ' Your changes has been saved.');
        dispatch(isLoading(false));
        dispatch(getChannel(channelId, ['schemes,schemes.insurer']));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'Failed to perform this action.');
        dispatch(isLoading(false));
        // eslint-disable-next-line no-console
        console.error(error);
      });
  };
};

const createOwnerContent = (values) => {
  return (dispatch) => {
    dispatch(isLoading(true));
    return Axios.post('whitelabel-management/owner/create-owner-content', values)
      .then(() => {
        dispatch(isLoading(false));
        toastr.success('Success', 'White label saved');
        return true;
      })
      .catch((error) => {
        dispatch(isLoading(false));
        handleErrorResponse(error, 'Failed to save white label');
      });
  };
};

const clearData = () => {
  return (dispatch) => {
    dispatch({ type: channelActions.CLEAR_DATA });
  };
};

export const actions = {
  getChannel,
  getChannelByKey,
  setChannels,
  resetSelectedChannel,
  createChannel,
  isLoading,
  getAllInsurers,
  getAllSchemes,
  updateChannel,
  clearData,
  updateWhitelabel,
  createOwnerContent,
};
